<template>
  <v-container fluid>
    <v-card-actions>
      <v-btn-toggle 
        v-model="toggle" 
        mandatory
        group
        color="primary"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn 
              text 
              icon
              v-on="on"
              @click="showActivePositions = 1"
            >
              <v-icon>select_all</v-icon>
            </v-btn>
          </template>
          <span>Active Positions</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn 
              text
              icon 
              v-on="on"
              @click="showActivePositions = 0"
            >
              <v-icon>delete_outline</v-icon>
            </v-btn>
          </template>
          <span>Trash</span>
        </v-tooltip>
      </v-btn-toggle>
      <v-divider
        class="mr-5"
        vertical
      />
      <div v-show="showActivePositions">
        <setup-positions-dialog-create
          v-if="$hasPermissionTo([
            'update position approval level',
            'create positions'
          ])"
          @created="loadPositions"
        />
      </div>
      <v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer />
      <!-- <v-autocomplete
        :items="categories"
        :loading="loadingCategories"
        class="hidden-sm-and-down"
        placeholder="Position Categories"
        label="Category"
        item-text="name"
        item-value="id"
        color="primary"
        hide-no-data
        hide-selected
        clearable        
        @change="filter"
      /> -->
    </v-card-actions>

    <v-row>
      <v-col 
        v-for="position in filteredPositions"
        :key="position.id"
        cols="12"
        md="4"
        xl="4"
      >
        <v-hover>
          <v-card 
            slot-scope="{ hover }"
            :class="[`elevation-${hover ? 12 : 2}`, 'pa-1']" 
          >
            <v-list one-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-medium text-capitalize px-0 font-18"
                  >
                    {{ position.name }}
                  </v-list-item-title>

                  <v-row no-gutters>
                    <v-col
                      cols="3"
                      class="font-14 py-custom-2"
                    >
                      Job Grade
                    </v-col>
                    <v-col cols="9">
                      <span class="pr-3">:</span>  
                      <b class="font-14">{{ ((position||{}).job_grade||{}).name || 'N/A' }}</b>
                    </v-col>

                    <v-col
                      cols="3"
                      class="font-14 py-custom-2"
                    >
                      Job Group
                    </v-col>

                    <v-col cols="9">
                      <span class="pr-3">:</span>  
                      <b class="font-14">{{ (((position||{}).job_grade||{}).job_group||{}).name || 'N/A' }}</b>
                    </v-col>

                    <v-col
                      cols="3"
                      class="font-14 py-custom-2"
                    >
                      Job Category
                    </v-col>
                    <v-col cols="9">
                      <span class="pr-3">:</span> 
                      <b class="font-14">{{ (((position||{}).job_grade||{}).job_category||{}).name || 'N/A' }}</b>
                    </v-col>

                    <v-col
                      cols="3"
                      class="font-14 py-custom-2"
                    >
                      Job Band
                    </v-col>

                    <v-col cols="9">
                      <span class="pr-3">:</span> 
                      <b class="font-14">{{ (((position||{}).job_grade||{}).job_band||{}).value || 'N/A' }}</b>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider light />
            <v-card-actions v-if="showActivePositions">
              <v-spacer />
              <setup-positions-approvals-dialog-edit-approval
                v-if="$hasPermissionTo(['update position approval level'])"
                :position="position" 
                @updated="loadPositions"
              /> 
              <setup-positions-dialog-edit
                :position="position" 
                @updated="loadPositions"
              /> 
              <setup-positions-dialog-delete
                :position="position" 
                @deleted="refreshData"
              /> 
            </v-card-actions>
            <v-card-actions v-else>
              <v-spacer />
              <setup-positions-dialog-restore
                :position="position" 
                @restored="refreshData"
              />
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-row
      v-show="filteredPositions.length === 0 && loading === false"
      justify="center"
    >
      <v-col
        class="text-center"
        cols="12"
      >
        <div class="headline">
          <span class="blue-grey--text">No Data Available</span>
        </div>
      </v-col>   
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupPositionsApprovalsDialogEditApproval: () => import('@/components/setup/positions/approvals/DialogEditApproval'),
      SetupPositionsDialogCreate: () => import('@/components/setup/positions/DialogCreate'),
      SetupPositionsDialogEdit: () => import('@/components/setup/positions/DialogEdit'),
      SetupPositionsDialogDelete: () => import('@/components/setup/positions/DialogDelete'),
      SetupPositionsDialogRestore: () => import('@/components/setup/positions/DialogRestore'),
    },
    metaInfo () {
      return {
        title: 'Setup - Positions',
      }
    },
    data () {
      return {
        categories: [],
        categoryFilterId: null,
        loading: true,
        positions: [],
        showActivePositions: 1,
        trashedPositions: [],
        toggle: 0,
      }
    },
    computed: {
      filteredPositions () {
        let positions = this.showActivePositions ? this.positions : this.trashedPositions

        return positions.filter(position => {
          if (this.categoryFilterId) {
            return position.position_category_id === this.categoryFilterId
          }        

          return position
        })
      },
    },
    watch: {
      showActivePositions: {
        immediate: true,
        handler (value) {
          if (value) {
            if (this.positions.length <= 0) this.loadPositions()
          } else {
            if (this.trashedPositions.length <= 0) this.loadTrashedPositions()
          }
        },
      },
    },
    created () {
      this.loadCategories()
    },
    methods: {
      refreshData () {
        this.loadPositions()
        this.loadTrashedPositions()
      },
      loadPositions () {
        this.$api.positions().list()
          .then(response => {
            this.positions = response.data
            this.loading = false
          })
      },
      loadTrashedPositions () {
        this.$api.positions().listTrashed()
          .then(response => {
            this.trashedPositions = response.data
            this.loading = false
          })
      },
      loadCategories () {
        this.loadingCategories = true

        this.$api.positionCategories().list()
          .then(response => {
            this.categories = response.data

            this.loadingCategories = false
          })
      },
      filter (value) {
        this.categoryFilterId = value
      },
    },
  }
</script>

<style scoped>
.font-18{
  font-size: 18px;
}

.font-14{
  font-size: 14px;
}

.py-custom-2{
  padding-top:2px;
  padding-bottom:2px;
}
</style>
